import * as React from "react"
import { FiSearch } from "react-icons/fi"
import loadable from "@loadable/component"
import * as styles from "./styles/index.css"

const SearchForm = loadable(() => import("./search-form"))

export default function SearchWidget() {
  const [open, setOpen] = React.useState(false)

  const toggle = () => {
    setOpen(!open)
  }
  const preload = () => {
    SearchForm.preload()
  }
  const close = () => {
    setOpen(false)
  }

  return (
    <>
      <button
        className={styles.searchButton}
        onMouseOver={preload}
        onFocus={preload}
        onClick={toggle}
      >
        <FiSearch />
        <span className={styles.hide}>Search</span>
      </button>
      {open && <SearchForm onClose={close} />}
    </>
  )
}
